//
// GraphElementController.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./DataVisualElementController";
import "@sas-dvr/ltjs-gtl/models/core/controller/DragMode";
import "../../models/visualElements/GraphElement";
import "@sas-dvr/ltjs-gtl/models/Graph";

var GraphElementController = createModule("BIRD_GraphElementController", [40040,40351,40490,40150,40201], EventDispatcher, [
    {
        INVALID_GRAPH_DATA_REFERENCE: 50005,
        INTERACTION_DISABLED: 50004,
        ROW_COLUMN_LIMIT_EXCEEDED: 50002,
        TITLE_CHANGED: 50013,
        GRAPH_MEASURE_RULE_CONFLICT: 50003,
        CURRENT_DRAG_MODE_CHANGED: 50012,
    },
    ,
    ,
    {
        dragMode: 4,
        categoryLabelDrillEnabled: 2,
    },
    {
        isOverviewSupported: [2],
        getModel: [1],
        toggleOverviewAxis: [0],
        getGraphModel: [1],
        selectShortestPath: [0],
        sort: [0,1],
        isOverviewAxisOn: [2],
        getAvailableDragModes: [[4]],
        playAnimation: [0],
        toggleOverview: [0],
        isOverviewOn: [2],
        isAnimated: [2],
        supportsSelectShortestPath: [2],
        pauseAnimation: [0],
    },
    {
        _create: [4,1],
    },
    ,
]);
export default GraphElementController;
